import {Subject} from 'rxjs';
import {Action} from "@ngrx/store";

export interface INotification {
  type: 'alert' | 'error' | 'success';
  title: string;
  message?: string;
}

export class FilemanagerNotifcations {
  public notification$ = new Subject<INotification>();

  public sendNotification(notification: INotification): Action {
    this.notification$.next(notification);
    return null;
  }

  public getNotificationStream(): Subject<INotification> {
    return this.notification$;
  }
}
